import React, { useState, useEffect, useMemo } from "react";
import { Theme, StandardProps } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import { StyleClassKey } from "js/react/typescript";

import { TextFieldWithError, AppButton } from "js/react/components";
import { DialogProps } from "@material-ui/core/Dialog";
import { getFieldState, ValidityState, isStateValid } from "js/types";
import {
    Validations,
    applyValidations,
    InputValidationRule
} from "js/helpers/ValidationHelpers";
import { DialogTitle } from "@material-ui/core";
import { Dialog } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";
import { DialogActions } from "@material-ui/core";

const styles = (theme: Theme) =>
    createStyles({
        root: {},
        title: {},
        content: {
            marginTop: theme.spacing(1),
            minWidth: 400
        },
        btn: {},
        fullWidth: {}
    });

type CreateFolderDialogClassKey = StyleClassKey<typeof styles>;

const useStyles = makeStyles(styles);

export interface CreateFolderDialogProps
    extends StandardProps<DialogProps, CreateFolderDialogClassKey> {
    loading: boolean;
    validityState: ValidityState;
    onCreate: (name: string) => void;
    onCancel: () => void;
}

function Component(props: CreateFolderDialogProps) {
    const classes = useStyles(props);
    const { classes: cls, loading, onCreate, validityState, ...rest } = props;
    const [name, setName] = useState("");
    const validationRule: InputValidationRule[] = [
        { rule: Validations.REQUIRED, message: "Directory name is required" }
    ];
    const [errorState, setErrorState] = useState(validityState);
    useEffect(() => {
        setErrorState(validityState);
    }, [validityState]);
    const initialErrors = useMemo(() => {
        return applyValidations([], validationRule, name, "directoryName");
    }, [errorState, name]);

    return (
        <Dialog className={classes.root} {...rest}>
            <DialogTitle>Enter folder name</DialogTitle>
            <DialogContent className={classes.content}>
                <TextFieldWithError
                    label={"Name"}
                    id={"name"}
                    errorInfo={getFieldState(initialErrors, "directoryName")}
                    value={name}
                    required
                    onChange={event => {
                        const val = event.target.value;
                        setName(val);
                    }}
                />
            </DialogContent>
            <DialogActions>
                <AppButton
                    className={classes.btn}
                    disabled={loading || !isStateValid(initialErrors)}
                    onClick={() => onCreate(name)}
                >
                    Create
                </AppButton>
            </DialogActions>
        </Dialog>
    );
}

Component.defaultProps = {} as CreateFolderDialogProps;
Component.displayName = "CreateFolderDialog";
export const CreateFolderDialog = Component;
export default CreateFolderDialog;
